import { DialogBoxService } from "@app/custom-shared/components/alerts/dialog-box-service";
import { ServiceInjector } from "../service-injector.module";
  
String.prototype.showError = function (): string {
    ServiceInjector.get(DialogBoxService).snackbarUtil.showError(this.toString());
    return this;
};

String.prototype.showInfo = function (): string {
    ServiceInjector.get(DialogBoxService).snackbarUtil.showInfo(this.toString());
    return this;
};

String.prototype.showWarn = function (): string {
    ServiceInjector.get(DialogBoxService).snackbarUtil.showWarn(this.toString());
    return this;
};

String.prototype.showSuccess = function (): string {
    ServiceInjector.get(DialogBoxService).snackbarUtil.showSuccess(this.toString());
    return this;
};

String.prototype.naturalNormalize = function (): string {
    return this.normalize('NFD').replace(/[^a-zA-Z0-9s]/g, "").toLocaleLowerCase();
};

String.prototype.isEmpty = function (): boolean {
    return this == null || this == undefined || this.length == 0;
};

String.prototype.isNotEmpty = function (): boolean {
    return !this.isEmpty()
};
